import { Redirect, Switch, useRouteMatch } from 'react-router-dom';
import * as AlertNotification from '@givebutter/primitives/alert-notification';
import { MetricsIndex } from './metrics/MetricsIndex';
import { EditEngageMessageDetailsDrawer } from 'assets/js/pages/engage/EditEngageMessageDetailsDrawer';
import { EngageIndex } from 'assets/js/pages/engage/EngageIndex';
import { EngageSettingsRouter } from 'assets/js/pages/engage/EngageSettingsRouter';
import Letters from 'assets/js/pages/engage/LettersRouter';
import { MessageBuilder } from 'assets/js/pages/engage/MessageBuilder';
import { DrawerRoute } from 'components/drawer-route';
import { Route } from 'components/router/Route';
import { useFlags } from 'launchdarkly-react-client-sdk';

const EngageRouter = () => {
    const match = useRouteMatch();
    const { engageAdminAlert } = useFlags();

    return (
        <>
            {engageAdminAlert && (
                <AlertNotification.Root
                    className={
                        'z-pentOutermost fixed left-4 right-4 top-4 max-w-lg md:left-1/2 md:-translate-x-1/2 md:transform [&_p]:leading-4'
                    }
                    type={'warning'}
                    closable={true}
                >
                    We are experiencing a high volume of Engage messages. This may cause messages to
                    take longer than normal to process.
                </AlertNotification.Root>
            )}
            <Switch>
                <Route component={EngageSettingsRouter} path={`${match.path}/settings`} />
                <Route path={`${match.path}/letters`} component={Letters} />
                <Route
                    path={`${match.path}/metrics/:channel/:message_id`}
                    component={MetricsIndexRouter}
                />
                <Route
                    exact
                    component={MessageBuilder}
                    path={`${match.path}/:channel/:message_id/edit`}
                />
                <Route component={EngageIndexRouter} path={`${match.path}/:channel`} />
                <Redirect to={`${match.url}/email`} />
            </Switch>
        </>
    );
};

const EngageIndexRouter = () => {
    const match = useRouteMatch();

    return (
        <>
            <DrawerRoute
                path={`${match.path}/:message_id/details/edit`}
                component={EditEngageMessageDetailsDrawer}
            />
            <Switch>
                <Route path={match.path} component={EngageIndex} />
            </Switch>
        </>
    );
};

const MetricsIndexRouter = () => {
    const match = useRouteMatch();

    return (
        <>
            <DrawerRoute path={`${match.path}/edit`} component={EditEngageMessageDetailsDrawer} />
            <Switch>
                <Route path={match.path} component={MetricsIndex} />
            </Switch>
        </>
    );
};

export default EngageRouter;
